import { combineReducers } from 'redux'
import locationReducer from './location'
import { localeReducer as locale } from 'react-localize-redux';

export const makeRootReducer = (asyncReducers) => {
	return (state, action) => {
		let stateBackup = {};
		if(action.type === 'STATE_RESET'){
			stateBackup.locale = state.locale;
		}
	//	console.log(stateBackup);
		return Object.assign(combineReducers({
		    location: locationReducer,
		    locale,
		    ...asyncReducers
		})(action.type === 'STATE_RESET' ? undefined : state, action),stateBackup)
	}
}



export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer





// import { combineReducers } from 'redux'
// import locationReducer from './location'
// import { localeReducer as locale } from 'react-localize-redux';

// export const makeRootReducer = (asyncReducers) => {
//   return combineReducers({
//     location: locationReducer,
//     locale,
//     ...asyncReducers
//   })
// }

// export const injectReducer = (store, { key, reducer }) => {
//   if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

//   store.asyncReducers[key] = reducer
//   store.replaceReducer(makeRootReducer(store.asyncReducers))
// }

// export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js